'use strict';
// jQuery extensions

/**
 * Show a spinner inside a given element
 * @param {element} $target - Element to block by the veil and spinner.
 *                            Pass body to block the whole page.
 * @param {boolean} (optional) - Default state shows white spinner on black, 30% opacity background.
 *                              Pass `true` to show brand's primary color spinner on a white 30% background.
 *                              Primary color spinner should be used on element-level spinners.
 */
 function addSpinner($target, showPrimary) {
    var colorClass = showPrimary ? 'primary' : 'white';
    var $veil = $('<div class="veil"><div class="underlay ' + colorClass + '-spinner"></div></div>');
    $veil.append('<div class="spinner spinner-border text-' + colorClass + '"></div>');
    if ($target.get(0).tagName === 'IMG') {
        $target.after($veil);
        $veil.css({ width: $target.width(), height: $target.height() });
        if ($target.parent().css('position') === 'static') {
            $target.parent().css('position', 'relative');
        }
    } else {
        $target.append($veil);
        if ($target.css('position') === 'static') {
            $target.parent().css('position', 'relative');
            $target.parent().addClass('veiled');
        }
        if ($target.get(0).tagName === 'BODY') {
            $veil.find('.spinner').css('position', 'fixed');
        }
    }
    $veil.click(function (e) {
        e.stopPropagation();
    });
}

/**
 * Remove existing spinner
 * @param  {element} $veil - jQuery pointer to the veil element
 */
function removeSpinner($veil) {
    if ($veil.parent().hasClass('veiled')) {
        $veil.parent().css('position', '');
        $veil.parent().removeClass('veiled');
    }
    $veil.off('click');
    $veil.remove();
}



module.exports = function () {
    // params
    // toggleClass - required
    // triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
    // eventName - optional. defaults to 'click'
    $.fn.toggledList = function (options) {
        if (!options.toggleClass) { return this; }
        var list = this;
        return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
            e.preventDefault();
            var classTarget = options.triggerSelector ? $(this).parent() : $(this);
            classTarget.toggleClass(options.toggleClass);
            // execute callback if exists
            if (options.callback) {options.callback();}
        });
    };

    $.fn.syncHeight = function () {
        var arr = $.makeArray(this);
        arr.sort(function (a, b) {
            return $(a).height() - $(b).height();
        });
        return this.height($(arr[arr.length - 1]).height());
    };


    // element level spinner:
    $.fn.spinner = function () {
        var $element = $(this);
        var Fn = function () {
            this.start = function (showPrimary) {
                if ($element.length) {
                    addSpinner($element, showPrimary);
                }
            };
            this.stop = function () {
                if ($element.length) {
                    var $veil = $('.veil');
                    removeSpinner($veil);
                }
            };
        };
        return new Fn();
    };

    // page-level spinner:
    $.spinner = function () {
        var Fn = function () {
            this.start = function (showPrimary) {
                addSpinner($('body'), showPrimary);
            };
            this.stop = function () {
                removeSpinner($('.veil'));
            };
        };
        return new Fn();
    };

};
